import React from "react"
import { useSelector } from "react-redux"

import "components/Steps/Stepper.css"
import { getDoctorTypeAnswer } from "containers/Survey/services/selector"
import { useLanguage } from "locales"
import { DoctorType } from "types/entity"

const PARCOURS_LABEL_KEYS: Partial<Record<DoctorType, string>> = {
  [DoctorType.GENERALIST]: "pathwayLabelGeneralist",
  [DoctorType.DERMATOLOGY]: "pathwayLabelDermatology",
  [DoctorType.CHECKUP]: "pathwayLabelCheckup",
  [DoctorType.PHARMACIST]: "pathwayLabelPrevention",
}

export const Steps: React.FC<{
  current?: number
  insideStep?: number
  totalInsideSteps?: number
  totalSteps?: number,
  visible?:boolean
}> = ({
  current = 0,
  insideStep = 1,
  totalInsideSteps = 1,
  totalSteps = 6,
}): JSX.Element => {
  const { languages } = useLanguage()
  const doctorType: DoctorType = useSelector(getDoctorTypeAnswer)
  const parcoursLabelKey = PARCOURS_LABEL_KEYS[doctorType]
  const parcoursLabel = parcoursLabelKey ? languages[parcoursLabelKey] : undefined

  const steps = Array.from({ length: totalSteps })
  if(current === 0) {
    return <></>
  }
  return (
    <div
      className="stepper-wrapper"
      style={{
        position: "absolute",
        top: "15px",
        left: "190px",
        maxWidth: "637px",
      }}
    >
      {parcoursLabel && <span className="parcours-label">{parcoursLabel}</span>}
      <div className="stepper">
        <span className="step-label">
          {current}/{totalSteps}
        </span>
        <div className="step-bar">
          {steps.map((_, i) => {
            const isSelected = i === current - 1
            const fillPercent =
              totalInsideSteps > 0 && isSelected
                ? (insideStep / totalInsideSteps) * 100
                : 0

            return (
              <div
                key={i}
                className={`step ${i < current - 1 ? "active" : ""} ${isSelected ? "selected-step" : ""}`}
              >
                {isSelected && (
                  <div
                    className="step-inner-fill"
                    style={{ width: `${fillPercent}%` }}
                  />
                )}
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
